module.exports = __webpack_public_path__ + "static/img/picture7.66daf07f.png";